import toast from 'react-hot-toast'

import { useMutation, useQueryClient } from '@fv/client-core'

import type { AdminLoad } from '@/types/admin-load'
import { adminFetch } from '@/utils'

async function refreshCarrierBOL(dto: { loadId: string }) {
  return adminFetch<AdminLoad>(`/loads/${dto.loadId}/refetch-bol`, {
    method: 'POST',
  })
}

export function useRefreshCarrierBOL() {
  const queryClient = useQueryClient()

  const mutation = useMutation(refreshCarrierBOL, {
    onError: (error: { message: string }) => {
      toast.error(error.message)
      mutation.reset()
    },
    onSuccess: (load: { _id: string }) => {
      queryClient.invalidateQueries({ queryKey: ['dispatch-list'] })
      queryClient.invalidateQueries({ queryKey: ['missing-bol-list'] })
      queryClient.setQueryData(['load', load._id], load)
      toast.success('BOL refreshed.')
      mutation.reset()
    },
  })

  return mutation
}
